<p>
  <mat-icon (click)="onBack()" class="clickable">keyboard_backspace</mat-icon>
  <span class="title-2-bold">{{title}}</span>
</p>
